/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * メディアリストの概要
 * @export
 * @interface MediaListOverview
 */
export interface MediaListOverview {
    /**
     * メディアリストのID
     * @type {number}
     * @memberof MediaListOverview
     */
    id: number;
    /**
     * メディアリストのタイトル
     * @type {string}
     * @memberof MediaListOverview
     */
    title: string;
    /**
     * メディアリストに登録されたメディアの総数
     * @type {number}
     * @memberof MediaListOverview
     */
    totalCount: number;
    /**
     * メール配信元アドレス
     * @type {string}
     * @memberof MediaListOverview
     */
    fromEmail: string;
}

/**
 * Check if a given object implements the MediaListOverview interface.
 */
export function instanceOfMediaListOverview(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "totalCount" in value;
    isInstance = isInstance && "fromEmail" in value;

    return isInstance;
}

export function MediaListOverviewFromJSON(json: any): MediaListOverview {
    return MediaListOverviewFromJSONTyped(json, false);
}

export function MediaListOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaListOverview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'totalCount': json['total_count'],
        'fromEmail': json['from_email'],
    };
}

export function MediaListOverviewToJSON(value?: MediaListOverview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'total_count': value.totalCount,
        'from_email': value.fromEmail,
    };
}

